import { api } from "@/lib/api";

const position = () =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("no-geo"));
    navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 });
  });

export async function pingNow(source = "auto", jobId = null) {
  try {
    const { coords } = await position();
    await api.post("/tech/tracking/ping", { lat: coords.latitude, lng: coords.longitude, accuracy: coords.accuracy, source, job_id: jobId });
  } catch {
    // posizione non disponibile o fuori orario: ignorata
  }
}
